<template>
  <div id="app">
    <notifications group="word-add" />
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
body,html{
  font-family: vazir;
}
.close{
    margin:0!important;
    padding:0!important;
}
#modal-1___BV_modal_content_{
  background:rgb(44, 100, 100);
  color: white;
}
</style>
